import React from 'react';
import styled from 'styled-components';

const TermsPage = () => {
    return (
        <TermsContainer>
            {/* Header Section */}
            <HeaderSection>
                <BackgroundLabel>TERMS</BackgroundLabel>
                <MainTitle>
                    Terms & Conditions
                </MainTitle>
            </HeaderSection>

            {/* Content Section */}
            <ContentSection>
                <TermsBlock>
                    <BlockTitle>1. Acceptation des conditions</BlockTitle>
                    <BlockText>
                        En accédant et en utilisant ce site web, vous acceptez d'être lié par ces termes et conditions, toutes les lois et réglementations applicables, et acceptez que vous êtes responsable du respect des lois locales applicables.
                    </BlockText>
                </TermsBlock>

                <TermsBlock>
                    <BlockTitle>2. Propriété intellectuelle</BlockTitle>
                    <BlockText>
                        L'ensemble du contenu présent sur ce site (textes, images, designs, logos, photos, vidéos, etc.) est la propriété exclusive de VOLTAUTO. Toute utilisation non autorisée de ce contenu constitue une violation des droits de propriété intellectuelle.
                    </BlockText>
                </TermsBlock>

                <TermsBlock>
                    <BlockTitle>3. Confidentialité des données</BlockTitle>
                    <BlockText>
                        Nous nous engageons à protéger vos données personnelles conformément à notre politique de confidentialité. Les informations collectées sont utilisées uniquement dans le cadre de l'amélioration de nos services et ne sont jamais partagées avec des tiers sans votre consentement explicite.
                    </BlockText>
                </TermsBlock>

                <TermsBlock>
                    <BlockTitle>4. Limitation de responsabilité</BlockTitle>
                    <BlockText>
                        VOLTAUTO ne pourra être tenue responsable des dommages directs ou indirects résultant de l'utilisation de ce site web ou de l'impossibilité d'y accéder. Nous nous réservons le droit de modifier, suspendre ou interrompre tout aspect du site à tout moment.
                    </BlockText>
                </TermsBlock>
            </ContentSection>

            {/* Contact Section */}
            <ContactSection>
                <ContactTitle>Des questions sur nos conditions ?</ContactTitle>
                <ContactButton href="/contact">
                    Contactez-nous
                </ContactButton>
            </ContactSection>
        </TermsContainer>
    );
};

export default TermsPage;


const TermsContainer = styled.div`
    min-height: 100vh;
    background: white;
    padding: 2rem 0;
`;

const HeaderSection = styled.header`
    padding: 4rem;
    position: relative;
    margin-bottom: 4rem;

    @media (max-width: 768px) {
        padding: 2rem;
    }
`;

const BackgroundLabel = styled.div`
    font-size: 1rem;
    color: rgba(0, 0, 0, 0.3);
    margin-bottom: 1rem;
    text-transform: uppercase;
    letter-spacing: 0.2em;
`;

const MainTitle = styled.h1`
    font-size: clamp(2.5rem, 5vw, 4rem);
    font-weight: 700;
    color: rgba(0, 0, 0, 0.8);
    line-height: 1.2;
    margin: 0;
`;

const ContentSection = styled.div`
    max-width: 900px;
    margin: 0 auto;
    padding: 0 2rem;
    display: flex;
    flex-direction: column;
    gap: 4rem;

    @media (max-width: 768px) {
        padding: 0 1rem;
        gap: 2rem;
    }
`;

const TermsBlock = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
`;

const BlockTitle = styled.h2`
    font-size: 1.5rem;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
`;

const BlockText = styled.p`
    font-size: 1.1rem;
    line-height: 1.6;
    color: rgba(0, 0, 0, 0.6);
`;

const ContactSection = styled.div`
    margin-top: 6rem;
    text-align: center;
    padding: 4rem 2rem;
    background: rgba(0, 0, 0, 0.02);

    @media (max-width: 768px) {
        margin-top: 4rem;
        padding: 2rem 1rem;
    }
`;

const ContactTitle = styled.h3`
    font-size: 2rem;
    font-weight: 600;
    margin-bottom: 2rem;
    color: rgba(0, 0, 0, 0.8);
`;

const ContactButton = styled.a`
    display: inline-block;
    padding: 1rem 2rem;
    background: black;
    color: white;
    text-decoration: none;
    border-radius: 4px;
    font-weight: 500;
    transition: all 0.3s ease;

    &:hover {
        background: #333;
        transform: translateY(-2px);
    }
`;

